import { useLocation, useNavigate } from "react-router-dom";
import BackArrowIcon from "../../../components/Icons/BackArrowIcon";
import DeleteIcon from "../../../components/Icons/DeleteIcon";
import PlusIcon from "../../../components/Icons/PlusIcon";
import { Controller, useForm } from "react-hook-form";
import { DatePicker } from "rsuite";
import { useEffect, useState } from "react";
import ErrorMessage from "../../../components/comman/ErrorMessage";
import { Spinner } from "reactstrap";
import { useSelector } from "react-redux";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { toast } from "react-toastify";
import moment from "moment";
import UploadPlusIcon from "../../../components/Icons/UploadPlusIcon";
import ConfirmModal from "../../../components/comman/ConfirmModal";
import ViewDocumentModal from "../../Sites/ViewDocumentModal";
import BgBlurLoader from "../../../components/Loaders/BgBlurLoader";
import SearchSelectInput from "../../../components/comman/SearchSelectInput";
import { errorTypes } from "../../../utility/InputValidation";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import calculateFinancialYears from "../../../utility/CommonFunctions";

export default function CreatePurchaseRequest() {
  const navigate = useNavigate();
  const location = useLocation();
  // console.log("EditData=======>", location?.state?.EditData);
  const userDetails = useSelector((state) => state.root.userDetails);
  const [isLoading, setIsLoading] = useState(false);
  const [purchaseReqData, setPurchaseReqData] = useState();
  const [existingDocuments, setExistingDocuments] = useState([]);
  const [files, setFiles] = useState([]);
  const [selectedDocument, setSelectedDocument] = useState();
  const [modal, setModal] = useState(false);
  const toggleModal = () => {
    setModal(!modal);
  };

  const [expenseSections, setExpenseSections] = useState([
    { expenseHeadId: "", itemsList: [], items: [] },
  ]);
  const [expenseHeadList, setExpenseHeadList] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const toggleConfirmModal = () => setConfirmModal(!confirmModal);
  const [selectedId, setSelectedId] = useState("");
  const [state, setState] = useState({
    siteName: "",
    OandMSites: [],
    assignedSites: [],
    isLoadingSite: false,
  });
  const [financialYears, setFinancialYears] = useState([]);
  const [activeFinancialYear, setActiveFinancialYear] = useState("");

  // console.log("expenseHeadList========>",expenseHeadList)

  const {
    register,
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { errors },
    control,
  } = useForm();

  const RequestType = watch("type");
  const SiteId = watch("siteId");

  const getAssignedSites = (inputValue = null) => {
    const option = {
      method: "GET",
    };
    setState((prev) => ({
      ...prev,
      isLoadingSite: true,
    }));
    const url = `${apiUrl?.get_user_site}${inputValue ? `?search=${inputValue}` : ""
      }`;
    callApi(url, option).then((res) => {
      setState((prev) => ({
        ...prev,
        isLoadingSite: false,
      }));
      if (res?.status === true) {
        setState((prev) => ({
          ...prev,
          assignedSites: res?.data?.site?.map((item) => ({
            ...item,
            label: item?.site?.name,
            value: item?.site?.id,
          })),
        }));
      } else {
        toast.error(res?.message);
      }
    });
  };

  const handleFinancialYearCalculation = (siteData) => {
    const startDate = siteData?.startDate;
    const endDate = siteData?.endDate;

    let fyStartYear;
    const now = moment();
    const month = now.month() + 1;
    const year = now.year();

    if (!startDate || !endDate) {
      fyStartYear = month >= 4 ? year : year - 1;
      const currentFY = `${fyStartYear}-${fyStartYear + 1}`;
      setFinancialYears([currentFY]);
      setActiveFinancialYear(currentFY);
      setValue("financialYear", currentFY);
      return;
    }

    const fys = calculateFinancialYears(
      moment.utc(startDate).format("YYYY-MM-DD"),
      moment.utc(endDate).format("YYYY-MM-DD")
    );

    setFinancialYears(fys);

    fyStartYear = month >= 4 ? year : year - 1;
    const currentFY = `${fyStartYear}-${fyStartYear + 1}`;

    const selectedFY = fys.includes(currentFY) ? currentFY : fys[0] || "";
    // Only set default if not already set (e.g. from existing data) but here we might want to default to current year on new create
    if (!purchaseReqData?.financialYear) {
      setActiveFinancialYear(selectedFY);
      setValue("financialYear", selectedFY);
    }
  };

  useEffect(() => {
    getAssignedSites();
    if (location?.state?.EditData) {
      let options = {
        method: "GET",
      };
      let API =
        apiUrl?.get_purchase_request_detail +
        `?purchaseRequestId=${location?.state?.EditData?.id}`;
      setDataLoading(true);
      callApi(API, options).then((response) => {
        setDataLoading(false);
        if (response?.status === true) {
          setPurchaseReqData(response?.data);
        }
      });
    }
  }, []);

  useEffect(() => {
    if (RequestType) {
      GetExpenseHeadList();
    }
  }, [RequestType, SiteId, activeFinancialYear]);

  useEffect(() => {
    if (purchaseReqData) {
      setState((prev) => ({
        ...prev,
        siteName: purchaseReqData?.site?.name,
      }));
      setValue(
        "siteId",
        purchaseReqData?.site?.id || purchaseReqData?.siteId || ""
      );
      setValue("type", purchaseReqData?.type || "");
      setValue("date", moment(purchaseReqData?.date).format("YYYY-MM-DD"));
      setValue(
        "expectedDate",
        moment(purchaseReqData?.expectedDate).format("YYYY-MM-DD")
      );
      setValue("content", purchaseReqData?.description || "");
      if (purchaseReqData?.site) {
        handleFinancialYearCalculation(purchaseReqData?.site);
      }
      if (purchaseReqData?.financialYear) {
        setActiveFinancialYear(purchaseReqData?.financialYear);
        setValue("financialYear", purchaseReqData?.financialYear);
      }

      if (purchaseReqData?.purchaserequestexpenseheads?.length > 0) {
        const fetchAllItemsLists = async () => {
          const categoryParam = RequestType === "supplyRequest" ? "&category=supply" : (RequestType === "serviceRequest" ? "&category=service" : "");
          const updatedSections = await Promise.all(
            purchaseReqData.purchaserequestexpenseheads.map(async (section) => {
              let fetchedItemsList = [];
              try {
                const res = await callApi(
                  apiUrl.get_items + `all=true${categoryParam}`,
                  { method: "GET" }
                );
                const fetchedItems = res?.status === true ? res?.data?.item || res?.data || [] : [];
                fetchedItemsList = fetchedItems.map(item => ({
                  itemId: item.id,
                  item: item,
                  name: item.name,
                  hsnCode: item.hsnCode,
                  unitRate: item.rate || 0,
                  gst: item.gst || 0
                }));
              } catch (err) {
                console.error("Error fetching items list", err);
              }
              return {
                expenseHeadId: section?.expenseHeadId || "",
                itemsList: fetchedItemsList,
                items:
                  section?.supplyrequestitems?.map((item) => ({
                    itemId: item?.itemId || "",
                    name: item?.item?.name || item?.itemName || "",
                    hsnCode: item?.item?.hsnCode || item?.hsnCode || "",
                    quantity: item?.quantity || "",
                    amount: item?.amount || "",
                    description: item?.itemDescription || item?.description || "",
                    month: item?.month || "",
                  })) || [],
              };
            })
          );
          setExpenseSections(updatedSections);
        };
        fetchAllItemsLists();
      } else {
        setExpenseSections([{ expenseHeadId: "", items: [] }]);
      }
      if (purchaseReqData?.documents?.length > 0) {
        setExistingDocuments(purchaseReqData?.documents);
      }
    }
  }, [purchaseReqData, setValue, expenseHeadList]);

  const GetExpenseHeadList = () => {
    setExpenseSections([
      {
        expenseHeadId: "",
        itemsList: [],
        items: [{ itemId: "", quantity: "", amount: "", description: "" }],
      },
    ]);
    let options = {
      method: "GET",
    };
    let API =
      apiUrl.get_site_budget +
      `type=${RequestType === "supplyRequest" ? "supplyBudget" : "serviceBudget"
      }&from=purchaseRequest&siteId=${SiteId}&financialYear=${activeFinancialYear}`;
    if (SiteId) {
      callApi(API, options).then((response) => {
        if (response?.status === true) {
          setExpenseHeadList(response?.data);
        }
      });
    }
  };

  const handleExpenseHeadChange = (index, event) => {
    const selectedHeadId = event.target.value;
    const categoryParam = RequestType === "supplyRequest" ? "&category=supply" : (RequestType === "serviceRequest" ? "&category=service" : "");

    let options = { method: "GET" };
    callApi(apiUrl.get_items + `all=true${categoryParam}`, options).then((res) => {
      const fetchedItems = res?.status === true ? res?.data?.item || res?.data || [] : [];
      const mappedItems = fetchedItems.map(item => ({
        itemId: item.id,
        item: item,
        name: item.name,
        hsnCode: item.hsnCode,
        unitRate: item.rate || 0,
        gst: item.gst || 0
      }));

      setExpenseSections((prev) => {
        const updatedSections = [...prev];
        updatedSections[index] = {
          ...updatedSections[index],
          expenseHeadId: selectedHeadId,
          itemsList: mappedItems,
          items: [{ itemId: "", name: "", hsnCode: "", quantity: "", amount: "", description: "" }],
        };
        return updatedSections;
      });
    });
  };

  const handleItemChange = (expenseIndex, itemIndex, field, value) => {
    setExpenseSections((prev) => {
      const updatedSections = [...prev];
      const section = updatedSections[expenseIndex];
      const currentItem = section.items[itemIndex] || {};
      let updatedItem = {
        ...currentItem,
        [field]: value,
      };
      if (field == "itemId") {
        const selectedOption = section.itemsList?.find(
          (opt) => String(opt.itemId || opt.id) === String(value)
        );
        if (selectedOption) {
          const qty = Number(selectedOption?.quantity || 0);
          const freezed = Number(selectedOption?.freezedQuantity || 0);
          updatedItem = {
            ...updatedItem,
            itemId: value,
            name:
              selectedOption?.name ||
              selectedOption?.item?.name ||
              currentItem?.name,
            hsnCode:
              selectedOption?.hsnCode ||
              selectedOption?.item?.hsnCode ||
              currentItem?.hsnCode,
          };
        }
      }
      // Put it back
      updatedSections[expenseIndex].items[itemIndex] = updatedItem;
      return updatedSections;
    });
  };

  const addItem = (expenseIndex) => {
    setExpenseSections((prev) => {
      const updatedSections = [...prev];
      const section = updatedSections[expenseIndex];

      const selectedIds = section.items.map((i) => i.itemId);
      const unselectedItems = section.itemsList?.filter(
        (item) => !selectedIds.includes(item.itemId)
      );

      if (!unselectedItems || unselectedItems.length === 0) {
        toast.info("All items of this expense head are already added.");
        return prev; // No changes
      }

      // Add a new blank row
      section.items.push({ itemId: "", quantity: "", amount: "", description: "" });
      return updatedSections;
    });
  };

  // Remove Item
  const removeItem = (expenseIndex, itemIndex) => {
    setExpenseSections((prev) => {
      const updatedSections = [...prev];
      updatedSections[expenseIndex].items.splice(itemIndex, 1);
      return updatedSections;
    });
  };

  // Add New Expense Section
  const addExpenseSection = () => {
    setExpenseSections((prev) => [...prev, { expenseHeadId: "", items: [] }]);
  };

  // Remove Expense Section
  const removeExpenseSection = (index) => {
    setExpenseSections((prev) => prev.filter((_, i) => i !== index));
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      if (selectedFile.size > 6 * 1024 * 1024) {
        toast.error("File size must be less than 6MB");
        event.target.value = "";
        return;
      }
      setFiles((prevFiles) => [
        ...prevFiles,
        { key: selectedFile.name, file: selectedFile },
      ]);
    }
    event.target.value = "";
  };

  const removeFile = (fileName) => {
    setFiles((prevFiles) =>
      prevFiles.filter((fileObj) => fileObj.key !== fileName)
    );
  };

  const handleDeleteDocument = () => {
    const API = `${apiUrl.delete_document}?documentId=${selectedId}`;
    callApi(API, { method: "GET" }).then((response) => {
      toggleConfirmModal();
      if (response?.status === true) {
        setExistingDocuments((prev) =>
          prev.filter((doc) => doc.id !== selectedId)
        );
        // toast.success(response.message);
      } else {
        toast.error(response.message);
      }
    });
  };

  const ActionHandler = (id) => {
    setSelectedId(id);
    toggleConfirmModal();
  };

  const onSubmit = (data) => {
    let isValid = true;

    if (RequestType === "supplyRequest") {
      // Check if all expense heads are selected
      for (const section of expenseSections) {
        if (!section.expenseHeadId) {
          isValid = false;
          toast.info("Please select an Expense Head for all sections.");
          return;
        }

        // Check if all items are selected
        for (const item of section.items) {
          if (!item.itemId || !item.quantity || !item.amount) {
            isValid = false;
            toast.info("Please select all items and enter their quantity and amount.");
            return;
          }
          if (item.quantity && item.quantity == 0) {
            isValid = false;
            toast.info("Quantity should not be 0");
            return;
          }
        }
      }
    }

    if (!isValid) return;

    const submitData = {
      ...(!location?.state?.EditData?.siteId && { siteId: data?.siteId }),
      date: data?.date,
      expectedDate: data?.expectedDate,
      description: data?.content,
      type: data?.type,
      financialYear: activeFinancialYear,
      purchaseRequestExpenseHead: expenseSections?.map((section) => ({
        expenseHeadId: section.expenseHeadId,
        supplyRequestItem: section?.items?.map((item) => ({
          itemId: item?.itemId,
          quantity: item?.quantity,
          amount: item?.amount,
          itemDescription: item?.description,
          ...(RequestType === "serviceRequest" && { month: item?.month }),
        })),
      })),
    };

    const formData = new FormData();

    for (const key in submitData) {
      if (submitData[key] !== undefined && submitData[key] !== null) {
        if (key === "purchaseRequestExpenseHead") {
          formData.append(key, JSON.stringify(submitData[key]));
        } else {
          formData.append(key, submitData[key]);
        }
      }
    }

    files.forEach((f) => formData.append(f.file.name, f.file));

    const options = {
      method: "POST",
      form_data: formData,
    };
    const API = location?.state?.EditData
      ? apiUrl.update_purchase_request +
      `?purchaseRequestId=${location?.state?.EditData?.id}`
      : apiUrl.create_purchase_request;

    setIsLoading(true);
    callApi(API, options).then((response) => {
      setIsLoading(false);
      if (response?.status === true) {
        toast.success(response?.message);
        navigate(-1);
      } else {
        toast.error(response?.message);
      }
    });
  };

  return (
    <>
      {dataLoading && <BgBlurLoader />}
      <div className="content container-fluid">
        <div className="content-head mb-5 d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center justify-content-start gap-4">
            <button
              onClick={() => navigate(-1)}
              role="button"
              className="btn back-arrow"
            >
              <BackArrowIcon />
            </button>
            <h1 className="mb-0">
              {purchaseReqData ? "Update" : "Create"} Purchase Request
            </h1>
          </div>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-12 col-md-6 col-lg-3">
                  <div className="form-group mb-3">
                    <Controller
                      name="siteId"
                      control={control}
                      rules={{ ...errorTypes.required("site") }}
                      render={({ field, fieldState }) => (
                        <SearchSelectInput
                          label="Site"
                          placeholder="Search Site"
                          value={state.siteName}
                          onSelect={(option) => {
                            field.onChange(option?.value);
                            setState((pre) => ({
                              ...pre,
                              siteName: option?.label,
                            }));
                            setValue("siteId", option?.value);
                            // Find the full site object from assignedSites
                            const selectedSite = state.assignedSites.find(s => s.site.id === option.value);
                            if (selectedSite) {
                              handleFinancialYearCalculation(selectedSite.site);
                            }
                          }}
                          onBlur={field.onBlur}
                          errors={fieldState.error?.message}
                          options={state.assignedSites}
                          onSearch={getAssignedSites}
                          isLoading={state?.isLoadingSite}
                          showAddButton={false}
                          required={true}
                          disabled={purchaseReqData}
                        />
                      )}
                    />
                  </div>
                </div>
                <div className="col-12 col-md-6 col-lg-3">
                  <div className="form-group mb-3">
                    <label htmlFor="shiftName" className="form-label">
                      Request Type
                    </label>
                    <select
                      className="form-select form-control"
                      aria-label="Default select example"
                      {...register("type", {
                        required: "Type is required",
                      })}
                      disabled={purchaseReqData}
                    >
                      <option value="" className="d-none">
                        Select Request Type
                      </option>
                      <option value="supplyRequest">Supply</option>
                      <option value="serviceRequest">Service</option>
                    </select>
                    <ErrorMessage message={errors?.type?.message} />
                  </div>
                </div>

                <div className="col-12 col-md-6 col-lg-3">
                  <div className="form-group mb-3">
                    <label className="form-label" htmlFor="bDate">
                      Date
                    </label>
                    <Controller
                      name="date"
                      control={control}
                      rules={{
                        required: "This field is Required",
                        validate: (value) => {
                          const checkDate = moment(value).startOf('day');
                          const today = moment().startOf('day');
                          if (checkDate.isAfter(today)) {
                            return "Future dates are not allowed";
                          }
                          return true;
                        }
                      }}
                      defaultValue={moment().format("YYYY-MM-DD")}
                      render={({ field }) => (
                        <DatePicker size="sm"
                          {...field}
                          id="bDate"
                          format="dd/MM/yyyy"
                          oneTap
                          placeholder="dd/mm/yyyy"
                          style={{ width: "100%" }}
                          value={field.value ? new Date(field.value) : null}
                          onChange={(date) => {
                            field.onChange(date ? moment(date).format("YYYY-MM-DD") : "");
                          }}
                          cleanable={false}
                        />
                      )}
                    />
                    <ErrorMessage message={errors?.date?.message} />
                  </div>
                </div>
                <div className="col-12 col-md-6 col-lg-3">
                  <div className="form-group mb-3">
                    <label className="form-label" htmlFor="dDate">
                      Expected Date
                    </label>
                    <Controller
                      name="expectedDate"
                      control={control}
                      rules={{
                        required: "This field is Required",
                        validate: (value) => {
                          const checkDate = moment(value).startOf('day');
                          const date = watch("date");
                          if (date && checkDate.isBefore(moment(date).startOf('day'))) {
                            return "Expected date cannot be before request date";
                          }
                          return true;
                        }
                      }}
                      render={({ field }) => (
                        <DatePicker size="sm"
                          {...field}
                          id="dDate"
                          format="dd/MM/yyyy"
                          oneTap
                          placeholder="dd/mm/yyyy"
                          style={{ width: "100%" }}
                          value={field.value ? new Date(field.value) : null}
                          onChange={(date) => {
                            field.onChange(date ? moment(date).format("YYYY-MM-DD") : "");
                          }}
                          shouldDisableDate={(date) => date < new Date(moment().startOf('day'))}
                          cleanable={false}
                        />
                      )}
                    />
                    <ErrorMessage message={errors?.expectedDate?.message} />
                  </div>
                </div>

                <div className="col-12 col-md-6 col-lg-3">
                  <div className="form-group mb-3">
                    <label className="form-label">Financial Year</label>
                    <Controller
                      name="financialYear"
                      control={control}
                      render={({ field }) => (
                        <select
                          className="form-select"
                          {...field}
                          onChange={(e) => {
                            field.onChange(e.target.value);
                            setActiveFinancialYear(e.target.value);
                          }}
                          disabled={!SiteId || !!location?.state?.EditData}
                          value={activeFinancialYear}
                        >
                          {financialYears?.map((fy) => (
                            <option key={fy} value={fy}>
                              {fy}
                            </option>
                          ))}
                        </select>
                      )}
                    />
                  </div>
                </div>

                {/* Supply Request Section*/}
                <div className="col-12">
                  {expenseSections.map((section, expenseIndex) => (
                    <div key={expenseIndex} className="card-box mb-3">
                      <div className="row">
                        <div className="col-12 col-md-6 col-lg-4">
                          <div className="form-group mb-3">
                            <label className="form-label">Expense Head</label>
                            <select
                              className="form-select form-control"
                              value={section.expenseHeadId || ""}
                              onChange={(e) =>
                                handleExpenseHeadChange(expenseIndex, e)
                              }
                            >
                              <option value="" disabled>
                                Select Expense Head
                              </option>
                              {expenseHeadList?.length > 0 ? (
                                expenseHeadList?.map((item) => (
                                  <option
                                    key={item.expensehead.id}
                                    value={item.expensehead.id}
                                    disabled={
                                      expenseSections.some(
                                        (expense) =>
                                          expense.expenseHeadId ===
                                          item.expensehead.id
                                      )
                                    }
                                  >
                                    {item.expensehead.name}
                                  </option>
                                ))
                              ) : (
                                <option value="" disabled>
                                  No data available
                                </option>
                              )}
                            </select>
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="d-flex justify-content-between align-items-center">
                            <h4 className="fs-3 rajdhani-semibold my-4">
                              Item Details
                            </h4>
                            <button
                              className="btn btn-outline-primary mx-2"
                              type="button"
                              onClick={() => addItem(expenseIndex)}
                              disabled={!section.expenseHeadId}
                            >
                              <PlusIcon /> Add Items
                            </button>
                          </div>

                          <table className="table mt-3">
                            <thead>
                              <tr>
                                <th style={{ width: "25%" }}>Item <span className="text-danger">*</span></th>
                                <th style={{ width: "10%" }}>HSN Code</th>
                                {RequestType === "serviceRequest" && (
                                  <th style={{ width: "10%" }}>Month <span className="text-danger">*</span></th>
                                )}
                                <th style={{ width: RequestType === "serviceRequest" ? "10%" : "15%" }}>Quantity <span className="text-danger">*</span></th>
                                <th style={{ width: "15%" }}>Amount <span className="text-danger">*</span></th>
                                <th style={{ width: RequestType === "serviceRequest" ? "20%" : "25%" }}>Description</th>
                                <th style={{ width: "10%" }}>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {!section.expenseHeadId ? (
                                <tr>
                                  <td
                                    colSpan={RequestType === "serviceRequest" ? 7 : 6}
                                    className="text-center text-warning"
                                  >
                                    Please Select Expense Head
                                  </td>
                                </tr>
                              ) : section.items.length === 0 ? (
                                <tr>
                                  <td
                                    colSpan={RequestType === "serviceRequest" ? 7 : 6}
                                    className="text-center text-danger"
                                  >
                                    No items found. Click "Add Items" to re-add
                                    removed ones.
                                  </td>
                                </tr>
                              ) : (
                                section.items.map((item, itemIndex) => {
                                  const optionsList = section.itemsList?.map((option) => ({
                                    label: `${option.name || option.item?.name || ""} (HSN: ${option?.item?.hsnCode || option.hsnCode || "--"})`,
                                    value: option.itemId || option.id,
                                    disabled: section.items.some(
                                      (i, idx) => String(i.itemId) === String(option.itemId || option.id) && idx !== itemIndex
                                    ),
                                  })) || [];
                                  const selectedOption = section.itemsList?.find((i) => String(i.itemId || i.id) === String(item.itemId));
                                  console.log("DEBUG: item.itemId =", item.itemId, "itemsList =", section.itemsList, "selectedOption =", selectedOption);
                                  const selectedLabel = selectedOption
                                    ? `${selectedOption.name || selectedOption.item?.name || ""} (HSN: ${selectedOption?.item?.hsnCode || selectedOption.hsnCode || "--"})`
                                    : item.name
                                      ? `${item.name} (HSN: ${item.hsnCode || "--"})`
                                      : "";

                                  // Determine item details if already in the list
                                  const fullItem =
                                    section.itemsList?.find(
                                      (i) => String(i.itemId || i.id) === String(item.itemId)
                                    ) || {};

                                  return (
                                    <tr key={itemIndex}>
                                      <td>
                                        <SearchSelectInput
                                          label=""
                                          placeholder="Search Item"
                                          value={selectedLabel}
                                          options={optionsList}
                                          onSelect={(option) => {
                                            handleItemChange(
                                              expenseIndex,
                                              itemIndex,
                                              "itemId",
                                              option?.value
                                            );
                                          }}
                                          className="mb-0"
                                        />
                                      </td>
                                      <td>
                                        {fullItem?.item?.hsnCode ||
                                          fullItem?.hsnCode ||
                                          item.hsnCode ||
                                          "--"}
                                      </td>
                                      {RequestType === "serviceRequest" && (
                                        <td>
                                          <input
                                            type="number"
                                            className="form-control"
                                            placeholder="Month"
                                            onWheel={(e) => e.currentTarget.blur()}
                                            value={item.month || ""}
                                            onChange={(e) => {
                                              let value = e.target.value.replace(/[^0-9]/g, "");
                                              handleItemChange(
                                                expenseIndex,
                                                itemIndex,
                                                "month",
                                                value
                                              );
                                            }}
                                          />
                                        </td>
                                      )}
                                      <td>
                                        <input
                                          type="number"
                                          step="any"
                                          onWheel={(e) => e.target.blur()}
                                          className="form-control"
                                          min={0}
                                          value={item.quantity || ""}
                                          onChange={(e) => {
                                            let value = e.target.value.replace(
                                              /[^0-9.]/g,
                                              ""
                                            );

                                            // Prevent multiple decimal points
                                            if (value.split(".").length > 2) {
                                              value = value.substring(0, value.length - 1);
                                            }

                                            handleItemChange(
                                              expenseIndex,
                                              itemIndex,
                                              "quantity",
                                              value
                                            );
                                          }}
                                        />
                                      </td>
                                      <td>
                                        <input
                                          type="number"
                                          step="any"
                                          onWheel={(e) => e.target.blur()}
                                          className="form-control"
                                          min={0}
                                          value={item.amount || ""}
                                          onChange={(e) => {
                                            let value = e.target.value.replace(
                                              /[^0-9.]/g,
                                              ""
                                            );
                                            if (value.split(".").length > 2) {
                                              value = value.substring(0, value.length - 1);
                                            }
                                            handleItemChange(
                                              expenseIndex,
                                              itemIndex,
                                              "amount",
                                              value
                                            );
                                          }}
                                        />
                                      </td>
                                      <td>
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={item.description || ""}
                                          onChange={(e) => {
                                            handleItemChange(
                                              expenseIndex,
                                              itemIndex,
                                              "description",
                                              e.target.value
                                            );
                                          }}
                                        />
                                      </td>

                                      <td>
                                        <button
                                          className="btn btn-outline-danger"
                                          type="button"
                                          onClick={() =>
                                            removeItem(expenseIndex, itemIndex)
                                          }
                                        >
                                          <DeleteIcon />
                                        </button>
                                      </td>
                                    </tr>
                                  );
                                })
                              )}
                            </tbody>
                          </table>

                          {expenseSections.length > 1 && expenseIndex > 0 && (
                            <div className="text-end">
                              <button
                                className="btn btn-outline-danger ms-3 py-2"
                                type="button"
                                onClick={() =>
                                  removeExpenseSection(expenseIndex)
                                }
                              >
                                <DeleteIcon /> Remove Section
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}

                  {/* <div className="col text-end">
                    <button
                      className="btn btn-primary py-2 fw-bold"
                      type="button"
                      onClick={addExpenseSection}
                    >
                      <PlusIcon /> Add Section
                    </button>
                  </div> */}
                </div>

                <div className="row">
                  <div className="col-12  " />
                  <div className="col-12 col-md-6 col-lg-5">
                    <div className="form-group mb-3">
                      <label className="form-label" htmlFor="ref">
                        Uploads
                      </label>
                      <input
                        type="file"
                        className="form-control d-none"
                        id="documentUpload"
                        accept="image/*,application/pdf"
                        onChange={handleFileChange}
                      />
                      <label
                        htmlFor="documentUpload"
                        className="form-label rounded-4 cursor-pointer d-flex align-items-center justify-content-center"
                        style={{
                          display: "inline-block",
                          cursor: "pointer",
                          padding: 5,
                          backgroundColor: "rgb(245, 245, 245)",
                          borderRadius: 8,
                          minWidth: 150,
                        }}
                      >
                        <div className="d-flex flex-column">
                          <span className="placeholder-img">
                            <UploadPlusIcon />
                          </span>
                          <span className="text-muted">Choose Files </span>
                        </div>
                      </label>
                      <div className="preview-section p-1 mt-3" />
                    </div>
                  </div>
                </div>
                {/* File Preview Section */}
                <div className="preview-section p-1 mt-3 col-lg-5">
                  {files?.length > 0 &&
                    files.map((fileObj) => (
                      <div
                        key={fileObj.key} // Using file name as key
                        className="d-flex align-items-center justify-content-between p-1 border rounded mb-2"
                        style={{
                          backgroundColor: "#f8f9fa",
                          cursor: "pointer",
                        }}
                      >
                        <div
                          className="w-100"
                          onClick={() => {
                            setSelectedDocument(fileObj?.file);
                            toggleModal();
                          }}
                        >
                          <span className="fs-5">{fileObj?.file?.name}</span>
                        </div>
                        <button
                          className="text-danger mx-2 bg-light"
                          onClick={() => removeFile(fileObj.key)} // Remove using file name
                        >
                          <DeleteIcon />
                        </button>
                      </div>
                    ))}

                  {existingDocuments?.length > 0 &&
                    existingDocuments.map((doc) => (
                      <div
                        key={doc.key} // Using file name as key
                        className="d-flex align-items-center justify-content-between p-1 border rounded mb-2"
                        style={{
                          backgroundColor: "#f8f9fa",
                          cursor: "pointer",
                        }}
                      >
                        <div
                          className="w-100"
                          onClick={() => {
                            const docUrl = {
                              url: doc?.url,
                            };
                            setSelectedDocument(docUrl);
                            toggleModal();
                          }}
                        >
                          <span className="fs-5">{doc?.name}</span>
                        </div>
                        <button
                          type="button"
                          className="text-danger mx-2 bg-light"
                          onClick={() => ActionHandler(doc.id)}
                        >
                          <DeleteIcon />
                        </button>
                      </div>
                    ))}
                </div>

                {/* <div className="col-12 col-md-6 col-lg-8 w-100">
                  <div className="form-group mb-3">
                    <label htmlFor="desc" className="form-label">
                      Description
                      <span className="text-danger">*</span>
                    </label>
                    <textarea
                      className="form-control"
                      id="desc"
                      rows="3"
                      {...register("description", {
                        required: "This field is Required",
                      })}
                    />
                    <ErrorMessage message={errors?.description?.message} />
                  </div>
                </div> */}
                <div className="col-12 ">
                  <div className="form-group mb-3">
                    <label htmlFor="totalLeavePerMonth" className="form-label">
                      Description
                      {/* <span className="text-danger">*</span> */}
                    </label>
                    <Controller
                      name="content"
                      control={control}
                      rules={{
                        // required: "Description is required",
                      }}
                      render={({ field }) => (
                        <div>
                          <CKEditor
                            {...field}
                            editor={ClassicEditor}
                            data={field.value || ""}
                            onChange={(event, editor) => {
                              field.onChange(editor.getData());
                            }}
                            config={{
                              toolbar: [
                                "heading",
                                "|",
                                "bold",
                                "italic",
                                "underline",
                                "strikethrough",
                                "|",
                                "fontColor",
                                "fontBackgroundColor",
                                "fontFamily",
                                "fontSize",
                                "alignment",
                                "|",
                                "link",
                                "bulletedList",
                                "numberedList",
                                "blockQuote",
                                "undo",
                                "redo",
                              ],
                              image: {
                                toolbar: [
                                  "imageStyle:alignLeft",
                                  "imageStyle:alignCenter",
                                  "imageStyle:alignRight",
                                  "|",
                                  "imageTextAlternative",
                                ],
                              },
                              height: "500px", // custom height for CKEditor
                            }}
                          />
                          <ErrorMessage message={errors?.content?.message} />
                        </div>
                      )}
                    />
                  </div>
                </div>
              </div>
              <div className="d-flex gap-3 align-items-center justify-content-end">
                <button
                  className="btn btn-secondary px-5"
                  type="button"
                  onClick={() => navigate(-1)}
                >
                  Cancel
                </button>
                <button className="btn btn-primary px-5" type="submit">
                  {isLoading ? (
                    <Spinner />
                  ) : purchaseReqData ? (
                    "Update"
                  ) : (
                    "Create"
                  )}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
      <ConfirmModal
        modal={confirmModal}
        toggle={toggleConfirmModal}
        submitHandler={handleDeleteDocument}
        isLoading={isLoading}
      />
      <ViewDocumentModal
        modal={modal}
        toggle={toggleModal}
        selectedDocument={selectedDocument}
      />
    </>
  );
}
